<template>
  <h1>{{ $t("verifyEmailAddressPage.heading") }}</h1>

  <p v-if="$route.params.message !== undefined" :class="$route.params.class">
    {{ $route.params.message }}
  </p>

  <p>
    {{ $t("verifyEmailAddressPage.infoText") }}
  </p>

  <p>{{ $t("verifyEmailAddressPage.infoTextReload") }}</p>

  <i18n-t
    keypath="verifyEmailAddressPage.noEmailReceived"
    tag="p"
    v-if="showResendMail"
  >
    <a
      class="text-secondary"
      href="#"
      @click.prevent="resendEmailVerification"
      >{{ $t("verifyEmailAddressPage.resendEmail") }}</a
    >
    <span v-show="mailSent" class="ms-3 text-success">{{ $t("sent") }}</span>
  </i18n-t>
</template>

<script>
import auth from "@/firebase/auth";
import { sendEmailVerification } from "firebase/auth";

export default {
  name: "VerifyEmailAddress",
  data() {
    return {
      showResendMail: false,
      mailSent: false,
    };
  },
  methods: {
    async resendEmailVerification() {
      await sendEmailVerification(auth.currentUser);
      this.mailSent = true;
    },
  },
  async mounted() {
    if (!auth.currentUser) {
      return false;
    }

    setTimeout(() => {
      this.showResendMail = true;
    }, 8000);

    let emailVerified = auth.currentUser.emailVerified;

    while (!emailVerified) {
      await new Promise((resolve) => setTimeout(resolve, 5000));

      if (!auth.currentUser) {
        return false;
      }

      await auth.currentUser.reload();
      emailVerified = auth.currentUser.emailVerified;
      this.$store.commit("user/SET_USER", {
        emailVerified: auth.currentUser.emailVerified,
      });
    }

    this.$store.commit("SET_APP_LOADED_STATE", false);
    await this.$store.dispatch("authInit");
    await this.$router.push({ name: "profile" });
    this.$store.commit("SET_APP_LOADED_STATE", true);
  },
};
</script>

<style scoped></style>
